<template>
  <ExpenseFeeTable
    v-bind="$attrs"
    :empty-text="text.table.empty"
    :loading-text="text.table.loading"
    :labels="tableLabels"
  />
</template>

<script>
import ExpenseFeeTable from '@/components/expensesFees/ExpenseFeeTable.vue';
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('fees');

export default {
  name: 'FeesTable',
  components: {
    ExpenseFeeTable,
  },
  data() {
    return {
      text,
    };
  },
  computed: {
    tableLabels() {
      return {
        sortTitles: this.text.table.sortTitles,
        columns: this.text.table.columns,
        links: this.text.table.links,
        actions: this.text.table.actions,
      };
    },
  },
};
</script>
